import { render } from "./ClaimEmployeeAutocomplete.vue?vue&type=template&id=72b54ab6&scoped=true"
import script from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ClaimEmployeeAutocomplete.vue?vue&type=script&lang=js"

import "./ClaimEmployeeAutocomplete.vue?vue&type=style&index=0&id=72b54ab6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b54ab6"]])

export default __exports__